import { render, staticRenderFns } from "./DRBaseInfoComponent.vue?vue&type=template&id=39f016ff&scoped=true"
import script from "./DRBaseInfoComponent.vue?vue&type=script&lang=js"
export * from "./DRBaseInfoComponent.vue?vue&type=script&lang=js"
import style0 from "./DRBaseInfoComponent.vue?vue&type=style&index=0&id=39f016ff&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f016ff",
  null
  
)

export default component.exports